import * as React from 'react';

import {colors} from '../../../colors/colors';
import {Body} from '../../../typography/body';

import {getFormattedTimestampForChannelEvent} from '../../helpers';

import {getAssignmentBannerAction, getAssignmentBannerIcon} from './helpers';

type Props = {
    bannerType: 'assigned' | 'reassigned' | 'unassigned';
    changeTime: any;
    assigneeName: string | null | undefined;
};

export function AssignmentBanner(props: Props) {
    const action = getAssignmentBannerAction(props.bannerType, props.assigneeName);
    const Icon = getAssignmentBannerIcon(props.bannerType);

    return (
        <div className='flex justify-center full-width'>
            <Body size='small' color='light'>
                <span className='flex align-center'>
                    {Icon && (
                        <Icon size={14} color={colors.grey} className='mr-4' alignCenter={true} />
                    )}
                    <span className='truncate' title={action}>
                        {action}
                    </span>
                    ,&nbsp;
                    <span style={{minWidth: 'fit-content'}}>
                        {getFormattedTimestampForChannelEvent(props.changeTime)}
                    </span>
                </span>
            </Body>
        </div>
    );
}
